import firebase from 'firebase';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAZjjQ7wdAZtMKjQQ9aSVAup89AQc_qraQ",
    authDomain: "fordays-323e7.firebaseapp.com",
    databaseURL: "https://fordays-323e7.firebaseio.com",
    projectId: "fordays-323e7",
    storageBucket: "fordays-323e7.appspot.com",
    messagingSenderId: "394216393511",
    appId: "1:394216393511:web:f2dbc3470981ad3da33702",
    measurementId: "G-JJYK7GY4E9"
}

const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp;